import { render, staticRenderFns } from "./page-section.vue?vue&type=template&id=48b0b3fc&scoped=true&"
import script from "./page-section.vue?vue&type=script&lang=js&"
export * from "./page-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b0b3fc",
  null
  
)

export default component.exports